<template>
  <page-header-wrapper title="代客创建订单">
    <a-card :bordered="false">
      <cs-order-create-form :initial-user-id="$route.query.userId" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import CsOrderCreateForm from './CsOrderCreateForm'

export default {
  name: 'CsOrderCreate',
  components: { CsOrderCreateForm }
}
</script>
